import { Button, LoadingButton } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const BaseButtonStyles = {
  width: '100%',
  maxWidth: '300px',
};

interface ButtonProps {
  maxWidth?: string;
}

export const FilterButton = styled(Button)<ButtonProps>(({ theme, maxWidth }) => ({
  ...BaseButtonStyles,
  maxWidth,
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
  backgroundColor: theme.palette.common.white,
  gap: theme.spacing(1),
  '&:hover': {
    borderColor: theme.palette.action.active,
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const SubmitButton = styled(LoadingButton)<ButtonProps>(({ theme, maxWidth }) => ({
  ...BaseButtonStyles,
  maxWidth,
  color: theme.palette.common.white,
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const StyledTableContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 0, 12),
  },
  // Fixar a primeira coluna da tabela apenas no desktop
  '@media (min-width: 1024px)': {
    '& .sticky-col': {
      position: 'sticky',
      left: 0,
      zIndex: 2,
      background: theme.palette.background.paper,
    },
    '& thead .sticky-col': {
      background: '#d9d9d9',
      margin: 0,
      zIndex: 999,
    },
  },
}));

export const TableSkeletonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25),
}));
